import React, { useEffect, useState } from "react";
import { Spinner } from "./Spinner";
interface Props {
  timeBeforeSpinner?: number;
}
// TODO: Make a spinner
export const Loading: React.FC<React.PropsWithChildren<Props>> = ({
  timeBeforeSpinner = 0,
}) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(true);
    }, timeBeforeSpinner);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  if (loading) return <Spinner />;
  return null;
};
